module.exports = __webpack_public_path__ + "static/img/consult4-3.65766c81.png";